var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"isLoggedIn":_vm.isLoggedIn}}),_c('div',{staticClass:"menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/studio?type=art_standings"}},[_c('div',{staticClass:"thumb"},[_c('img',{attrs:{"src":"img/brl/preview/art_standings.png"}})]),_c('span',[_vm._v("Art of Racing"),_c('br'),_vm._v("Standings")])])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }